import React from 'react';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import imgIcon from 'assets/icons/upload-document/icon_format_img.svg';
import pdfIcon from 'assets/icons/upload-document/icon_format_pdf.svg';
import { LoanDocumentDto } from 'client';

type DocumentElementProps = {
	file: LoanDocumentDto;
	onDelete: (fileId: number) => void;
};

export const DocumentElement = ({ file, onDelete }: DocumentElementProps) => {
	return (
		<div
			style={{
				width: '85%',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'center',
				margin: '4px 16px',
				backgroundColor: 'white',
				padding: '8px',
				borderRadius: '4px',
			}}
		>
			<img alt="icon" src={file.extension?.match('pdf') ? pdfIcon : imgIcon} />
			<p
				className="body-bold"
				style={{
					overflow: 'clip',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
					direction: 'rtl',
					width: '60%',
					textAlign: 'left',
				}}
			>
				{file.name}
			</p>
			<DeleteOutlineIcon
				color="secondary"
				style={{
					cursor: 'pointer',
					fontSize: '24px',
				}}
				onClick={() => onDelete(file.id)}
			/>
		</div>
	);
};
